<template>
  <!-- Possible win and stake -->
  <div>
    <div class="single-event--row">
      <span>{{$t('vdog_betType')}}:</span>
      <span class="value-field">{{getBettingType(ticket).bettingType}}</span>
    </div>
    <div class="single-event--row">
        <!-- Type of bet -->
      <span>{{uppercase(getBettingType(ticket).bettingSubtype)}}</span>
      <span class="value-field">{{format(ticket.Factor)}}</span>
    </div>
    <div class="single-event--row" v-if="isPayloutATVisible(ticket)">
        <!-- Stake -->
      <span>{{$t('vdog_stakeBt')}}:</span>
      <span class="value-field bet-amount">{{format(ticket.PayIn)}} {{currency}}</span>
    </div>
    <div class="single-event--row" v-if="isPayloutATVisible(ticket)">
      <!-- Stake -->
      <span>{{$t('vdog_stakeAt')}}:</span>
      <span class="value-field bet-amount">{{format(ticket.PayInAT)}} {{currency}}</span>
    </div>
    <div class="single-event--row" v-if="!isPayloutATVisible(ticket)">
      <!-- Stake -->
      <span>{{$t('vdog_stake')}}:</span>
      <span class="value-field bet-amount">{{format(ticket.PayInAT)}} {{currency}}</span>
    </div>
  </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import VDogHelper from '@/mixins/VDogHelper'
import LanguageHelper from '@/mixins/LanguageHelper'
export default {
  mixins: [NumberFormat, VDogHelper, LanguageHelper],
  props: {
    ticket: {
      type: Object,
      required: true
    },
    currency: String
  },
  methods: {
    isPayloutATVisible: function (ticket) {
      return ticket.PayIn !== ticket.PayInAT
    },
    format: function (value) {
      return this.formatNumber(value / 100, this.getLanguageCodeForNumbers(), 2)
    },
    uppercase: function (value) {
      return value.toUpperCase()
    },
    getBettingType (ticket) {
      let bettingType = ''
      let bettingSubtype = ''
      let gameName = ticket.StakeTypeEnum || ticket.GameName
      let stakeEnum = ticket.StakeEnum || ticket.Options
      switch (gameName) {
        case 1:
          bettingType = this.$t('vdog_winner')
          bettingSubtype = this.$t('vdog') + ' ' + stakeEnum
          break
        case 2:
          bettingType = this.$t('vdog_in_first_2')
          bettingSubtype = this.$t('vdog') + ' ' + stakeEnum
          break
        case 3:
          bettingType = this.$t('vdog_in_first_3')
          bettingSubtype = this.$t('vdog') + ' ' + stakeEnum
          break
        case 4:
          bettingType = this.$t('vdog_not_a_winner')
          bettingSubtype = this.$t('vdog') + ' ' + stakeEnum
          break
        case 5:
          bettingType = this.$t('vdog_not_in_first_2')
          bettingSubtype = this.$t('vdog') + ' ' + stakeEnum
          break
        case 6:
          bettingType = this.$t('vdog_not_in_first_3')
          bettingSubtype = this.$t('vdog') + ' ' + stakeEnum
          break
        case 7:
          bettingType = this.$t('vdog_low_high')
          bettingSubtype = stakeEnum === 1 ? '1,2,3' : '4,5,6'
          break
        case 8:
          bettingType = this.$t('vdog_odd_even')
          bettingSubtype = stakeEnum === 1 ? this.$t('vdog_odd') : this.$t('vdog_even')
          break
        case 9:
          bettingType = this.$t('vdog_sum_1_2')
          bettingSubtype = stakeEnum === 1 ? '< 7.5' : '> 7.5'
          break
        case 10:
          bettingType = this.$t('vdog_sum_1_2_3')
          bettingSubtype = stakeEnum === 1 ? '< 10.5' : '> 10.5'
          break
        case 11:
          bettingType = this.$t('vdog_combination_betting')
          bettingSubtype = Math.floor((stakeEnum / 10) % 10) + ', ' + stakeEnum % 10
          break
        case 12:
          bettingType = this.$t('vdog_trifecta')
          bettingSubtype = Math.floor((stakeEnum / 100) % 10) + ', ' +
            Math.floor((stakeEnum / 10) % 10) + ', ' +
            stakeEnum % 10
          break
        case 13:
          bettingType = this.$t('vdog_double_chance')
          bettingSubtype = Math.floor((stakeEnum / 10) % 10) + ', ' + stakeEnum % 10
          break
      }
      return { 'bettingType': bettingType, 'bettingSubtype': bettingSubtype }
    }
  }
}
</script>
